import EA from '../helpers/init';
import Swiper from 'swiper';

export default EA.Methods.sliderBlocks = ($this) => {
    const swiperSlides = $this.querySelector('.swiper');

    new Swiper(swiperSlides, {
        speed: 600,
        slidesPerView: 1.2,
        spaceBetween: 16,
        breakpoints: {
            481: {
                slidesPerView: 2.2,
                spaceBetween: 16
            },
            601: {
                slidesPerView: 2.5,
                spaceBetween: 16
            },
            801: {
                slidesPerView: 4,
                spaceBetween: 16
            },
            1001: {
                slidesPerView: 4.8,
                spaceBetween: 16
            },
        }
    });


};
